var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper" },
    [
      _c(
        "el-upload",
        {
          staticClass: "avatar-uploader",
          attrs: {
            action: _vm.uploadActionUrl,
            "show-file-list": false,
            "on-success": _vm.onSuccess,
            "before-upload": _vm.beforeUpload
          }
        },
        [
          _vm.file_url
            ? _c("video", {
                staticClass: "avatar video-box",
                attrs: { src: _vm.file_url }
              })
            : _c("i", { staticClass: "el-icon-plus avatar-uploader-icon" })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }